"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarPaddingDay;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function CalendarPaddingDay(props) {
  const wrapperClasses = (0, _classnames.default)({
    "CalendarDay": true,
    "CalendarDay--padding": true
  });
  const contentClasses = (0, _classnames.default)({
    "CalendarDay-content": true,
    "CalendarDay-content--1stOfNextMonth": props.isInRange && props.date.format("D") === "1" && props.placeInRange !== "beginning" && props.placeInRange !== "not a range date picker",
    "CalendarDay-content--lastOfPrevMonth": props.isInRange && props.placeInRange !== "end" && props.placeInRange !== "not a range date picker" && props.date.format("DD") === props.date.endOf("month").format("DD"),
    "is-today": props.isToday
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClasses,
    "data-date": props.date.format("YYYY-MM-DD")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: contentClasses
  }));
}
CalendarPaddingDay.propTypes = {
  /** Date represented by this padding day */
  date: _propTypes.default.object.isRequired
};